import { useState, useEffect, useCallback } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Generate } from './pages/Generate';
import { Video } from './pages/Video';
import { Dashboard } from './pages/Dashboard';
import { Terms, Privacy, Compliance2257, Contact } from './pages/Legal';
import { PaymentRules } from './pages/PaymentRules';
import { TakeItDownReport } from './pages/TakeItDownReport';
import { getStorageValue } from '@genfun/core/utils';
import { fetchUser, logPageView } from '@genfun/core/api/auth';
import { GoogleOAuthProvider } from '@react-oauth/google';

function MainApp() {
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const [signedIn, setSignedIn] = useState(false);
  const [page, setPage] = useState('video');

  const gid = process.env.REACT_APP_GOOGLE_ID || '';

  const refreshUser = useCallback(async () => {
    const t = getStorageValue("igenfuntoken", null, setToken);
    if (!t) { setUser(null); return; }
    const [u, status] = await fetchUser(t);
    if (status === 401) {
      setToken(null);
      setUser(null);
    } else {
      setUser(u);
    }
  }, []);

  useEffect(() => { refreshUser(); }, [signedIn, refreshUser]);

  useEffect(() => {
    const refParam = new URLSearchParams(window.location.search).get('ref');
    if (refParam && !localStorage.getItem('referral_code')) {
      localStorage.setItem('referral_code', refParam);
    }
    if (!user) {
      const ref = refParam || localStorage.getItem('referral_code');
      logPageView(ref);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let content;
  if (page === 'video') {
    content = <Video token={token} user={user} setSignedIn={setSignedIn} onNavigate={setPage} refreshUser={refreshUser} />;
  } else if (page === 'terms') {
    content = <Terms onNavigate={setPage} />;
  } else if (page === 'privacy') {
    content = <Privacy onNavigate={setPage} />;
  } else if (page === 'compliance') {
    content = <Compliance2257 onNavigate={setPage} />;
  } else if (page === 'contact') {
    content = <Contact onNavigate={setPage} />;
  } else if (page === 'payment') {
    content = <PaymentRules onNavigate={setPage} token={token} refreshUser={refreshUser} />;
  } else if (page === 'report') {
    content = <TakeItDownReport onNavigate={setPage} />;
  } else {
    content = <Generate token={token} user={user} setSignedIn={setSignedIn} onNavigate={setPage} refreshUser={refreshUser} />;
  }

  return gid
    ? <GoogleOAuthProvider clientId={gid}>{content}</GoogleOAuthProvider>
    : content;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/refferal/dude" element={<Dashboard />} />
        <Route path="*" element={<MainApp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
